<template>
  <aside class="sidebar" :class="{ collapsed: collapsed }">
    <router-link :to="{ name: 'SuperAdminClinics' }"
                 class="d-block sidebar__logo-wrapper">
      <img src="/images/general/logo_short.png" class="sidebar__logo sidebar__logo-short"/>
      <img src="/images/general/logo.png" class="sidebar__logo sidebar__logo-full"/>
    </router-link>
    <MenuToggler view="sidebar"/>
    <div class="sidebar__menu">
      <template v-for="(m, mind) in topmenu">
        <div v-if="!m.right || (m.right && rights.includes(m.right))"
             :key="`topmenu-${mind}`"
             class="side-menu-item">
          <router-link class="sidebar__item" :to="m.to">
            <component :is="m.i" :class="`sidebar__svg-${m.title}`"/>
            <span class="sidebar__title">{{ $t(m.title) }}</span>
          </router-link>
        </div>
      </template>
    </div>
  </aside>
</template>

<script setup>
import ClinicSvg from '@/assets/svg-vue/sidebar/clinic.svg'
import DollarSvg from '@/assets/svg-vue/sidebar/dollar.svg'
import NoteSvg from '@/assets/svg-vue/sidebar/note.svg'
import MarketingSvg from '@/assets/svg-vue/sidebar/marketing.svg'
import TemplatesSvg from '@/assets/svg-vue/sidebar/template.svg'
import APISvg from '@/assets/svg-vue/sidebar/crm.svg'
import UserSvg from '@/assets/svg-vue/header/user.svg'
import ShieldSvg from '@/assets/svg-vue/sidebar/shield.svg'
import SadSvg from '@/assets/svg-vue/sidebar/sad.svg'
import MarketSvg from '@/assets/svg-vue/sidebar/market.svg'
import LogSvg from '@/assets/svg-vue/sidebar/log.svg'
import TranslateSvg from '@/assets/svg-vue/sidebar/process.svg'
import PaperSvg from '@/assets/svg-vue/sidebar/paper.svg'
import BlackListSvg from '@/assets/svg-vue/sidebar/black_list.svg'
import MenuToggler from "@/components/parts/header/MenuToggler"
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

const collapsed = computed(() => store.state.dom.sidebarCollapsed)
const rights = computed(() => store.state.auth.rights)

// the menu depends on the role, read once; a plain array, so that the svg components are not made reactive
const role = store.state.auth.user.role
let topmenu = [
  { i: ClinicSvg, to: '/superadmin/clinics', title: 'clinics' },
  { i: DollarSvg, to: '/superadmin/payments/list', title: 'payments' },
  { i: NoteSvg, to: '/superadmin/tariffs', title: 'tariffs' },
  { i: MarketingSvg, to: '/superadmin/notifications', title: 'notifications' },
  { i: TemplatesSvg, to: '/superadmin/popups', title: 'popup' },
  { i: APISvg, to: '/superadmin/api', title: 'api' },
  { i: BlackListSvg, to: '/superadmin/black-list-emails', title: 'ЧС Email' }
]
if(['manager', 'tech_specialist'].includes(role)) {
  topmenu = [
    { i: ClinicSvg, to: '/superadmin/clinics', title: 'clinics' },
    { i: BlackListSvg, to: '/superadmin/black-list-emails', title: 'ЧС Email' }
  ]
}
if(['account_manager'].includes(role)) {
  topmenu = [
    { i: ClinicSvg, to: '/superadmin/clinics', title: 'clinics' },
    { i: DollarSvg, to: '/superadmin/payments/list', title: 'payments' },
  ]
}
if(role === 'superadmin') {
  topmenu.push({ i: UserSvg, to: '/superadmin/users', title: 'users' })
  topmenu.push({ i: ShieldSvg, to: '/superadmin/dictionaries/countries', title: 'Справочники' })
  topmenu.push({ i: LogSvg, to: '/superadmin/logs/auth', title: 'Логи' })
}
if(['superadmin', 'tech_specialist'].includes(role)) {
  topmenu.push({ i: TemplatesSvg, to: '/superadmin/templates/treatment', title: 'Шаблоны' })
}
if(role === 'superadmin') {
  topmenu.push({ i: MarketSvg, to: '/superadmin/market', title: 'Маркет приложений' })
  topmenu.push({ i: PaperSvg, to: '/superadmin/legal-documents', title: 'Документы' })
  topmenu.push({ i: SadSvg, to: '/superadmin/developer', title: 'Уголок разраба' })
  topmenu.push({ i: TranslateSvg, to: '/superadmin/translator', title: 'Переводчик' })
}
</script>

<style scoped lang="scss">
.sidebar__svg-report {
  margin-left: 1px;
}
</style>
